import styled from 'styled-components';

const StyledSection = styled.section`
  margin-bottom: 1.25rem;
`;

const StyledSectionLabel = styled.h4`
  font-size: ${({ theme }) => theme.fontSizes.xs};
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: ${({ theme }) => theme.colors.textMuted};
  margin: 0 0 0.625rem;
`;

const StyledMuted = styled.p`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.textMuted};
  font-weight: 300;
`;

const StyledRequiredHint = styled.p`
  margin-top: 0.375rem;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.textMuted};
  font-weight: 300;
`;

const StyledRequiredMark = styled.span`
  color: ${({ theme }) => theme.colors.dangerText};
  font-weight: 700;
`;

const StyledAddInputWrapper = styled.div`
  margin-top: 0.5rem;
`;

const StyledAddInputButton = styled.button`
  font-size: ${({ theme }) => theme.fontSizes.sm};
`;

export default {
  StyledSection,
  StyledSectionLabel,
  StyledMuted,
  StyledRequiredHint,
  StyledRequiredMark,
  StyledAddInputWrapper,
  StyledAddInputButton,
};
